import React from 'react';

const Partners: React.FC = () => {
  // Visible partners with logos
  const visiblePartners = [
    {
      name: 'Vitruvian Intelligence',
      logo: '/logos/VitruvianIntelligenceLogo.png', // Placeholder path - replace with actual logo paths
      url: 'https://www.vitruvianintelligence.ai'
    },
    {
      name: 'Terakraft',
      logo: '/logos/TerakraftLogo.png',
      url: 'https://terakraft.no'
    },
    {
      name: 'Noctis AI',
      logo: '/logos/NoctisAILogo.png',
      url: 'https://noctisai.com'
    }
  ];

  // Invisible partners (SEO/backlinks only)
  const invisiblePartners = [
    {
      name: 'Tenders Club',
      url: 'https://tenders.club'
    },
    {
      name: 'Ufficio Appalti',
      url: 'https://ufficioappalti.com'
    },
    {
      name: 'Vitruvian Intelligence',
      url: 'https://www.vitruvianintelligence.com'
    },
  ];

  return (
    <div className="w-full mt-12 mb-8 border-t border-terminal-green/30 pt-8">
      <h2 className="text-xl font-vt323 mb-10 text-terminal-green text-center">PARTNERS</h2>
      
      <div className="flex flex-wrap justify-center items-start gap-16 md:gap-24 mb-6">
        {visiblePartners.map((partner, index) => (
          <a 
            key={index} 
            href={partner.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex flex-col items-center hover:opacity-80 transition-opacity"
          >
            <img 
              src={partner.logo} 
              alt={`${partner.name} logo`} 
              className="h-12 md:h-16 object-contain mb-2" 
            />
            <span className="text-xs text-terminal-green/70 text-center">{partner.name}</span>
          </a>
        ))}
      </div>
      
      {/* Invisible links for SEO - hidden visually but accessible to crawlers */}
      <div className="sr-only">
        {invisiblePartners.map((partner, index) => (
          <a 
            key={index} 
            href={partner.url} 
            target="_blank" 
            rel="noopener noreferrer"
          >
            {partner.name}
          </a>
        ))}
      </div>
    </div>
  );
};

export default Partners;